import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <Section dark className="overflow-hidden" data-id="element-127">
      <div className="absolute top-0 right-0 w-64 h-64 bg-red-600 rounded-full blur-[120px] opacity-20 pointer-events-none" data-id="element-128"></div>

      <div className="text-center mb-16" data-id="element-129">
        <span className="text-red-500 font-mono tracking-widest uppercase mb-4 block" data-id="element-130">
          La Solución
        </span>
        <h2 className="text-5xl md:text-7xl font-bold text-white mb-6" data-id="element-131">
          Sistema de Operador de Ingresos™
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-132">
          Protocolo Antipobreza™ no es otro curso. Es un sistema de 90 días
          para convertirte en un hombre que produce dinero bajo demanda.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 mt-12" data-id="element-133">
        <div className="border border-white/20 p-8 md:p-10 bg-white/5 backdrop-blur-sm" data-id="element-134">
          <div className="text-red-500 font-bold text-6xl mb-6 opacity-50" data-id="element-135">
            01
          </div>
          <h3 className="text-3xl font-bold text-white mb-4" data-id="element-136">
            Palanca #1: Habilidades high-income
          </h3>
          <p className="text-gray-300 mb-6 text-lg" data-id="element-137">
            En vez de buscar "ideas", aprendes a vender una habilidad simple que
            empresas ya pagan hoy:
          </p>
          <ul className="space-y-3 text-white" data-id="element-138">
            {['Conseguir leads', 'Agendar citas', 'Cerrar ventas'].map(item => <li key={item} className="flex items-center" data-id="element-139">
                  <Check className="w-5 h-5 text-red-500 mr-3" data-id="element-140" />
                  {item}
                </li>)}
          </ul>
        </div>

        <div className="border border-white/20 p-8 md:p-10 bg-white/5 backdrop-blur-sm" data-id="element-141">
          <div className="text-red-500 font-bold text-6xl mb-6 opacity-50" data-id="element-142">
            02
          </div>
          <h3 className="text-3xl font-bold text-white mb-4" data-id="element-143">
            Palanca #2: Flujo de caja inmediato
          </h3>
          <p className="text-gray-300 mb-6 text-lg" data-id="element-144">
            En vez de esperar meses a que algo "escale", cobras $500–$2,000 por
            cliente desde el primer mes.
          </p>
          <div className="bg-red-900/20 border border-red-900/50 p-4 text-red-200 text-sm font-mono" data-id="element-145">
            Esto evita el patrón que te tiene atrapado: <br data-id="element-146" />
            ilusión → intento → fracaso → vergüenza → abandono.
          </div>
        </div>
      </div>
    </Section>;
}